export default __webpack_public_path__ + "static/media/graduate.8bd84868.svg";